export default __webpack_public_path__ + "static/ambient-dark-d3bb6eefd04846d40fbc96dfbc19c218.png";